import Marionette from 'backbone.marionette';
import journalEventBillItemviewTmpl from '../templates/journal_event_bill_itemview.tpl';
export default Marionette.ItemView.extend({
  template: journalEventBillItemviewTmpl,
  tagName: "dd"
});